import { render, staticRenderFns } from "./AllGrinderDeleted.vue?vue&type=template&id=5ebb41d5&scoped=true"
import script from "./AllGrinderDeleted.vue?vue&type=script&lang=js"
export * from "./AllGrinderDeleted.vue?vue&type=script&lang=js"
import style0 from "./AllGrinderDeleted.vue?vue&type=style&index=0&id=5ebb41d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebb41d5",
  null
  
)

export default component.exports